import styled from 'styled-components';

import { CHART_BACKGROUND_COLOR, CHART_LABEL_COLOR } from '../../../utils/colors';
import { getSize } from '../charts.helper';

export const Container = styled.div`
  width: ${getSize('width')};
  height: ${getSize('height')};
  display: flex;
  background-color: ${CHART_BACKGROUND_COLOR};
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
  font-size: 0.8em;
  color: ${CHART_LABEL_COLOR};
`;
